import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconVersionDiff({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M10.5 10.25a2.5 2.5 0 1 0-5 0 2.5 2.5 0 0 0 5 0z"/>
            <path stroke={fill} d="M1 10.25a7 7 0 0 1 14 0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    );
}

export default IconVersionDiff;
